<template>
  <div class="container">
    <div class="sign-container">
      <div class="sign-frame">
        <div class="sign-side blue">
          <img :src="this.baseURL + '/mascots/funny.svg'" alt="DS Mascot" />
          <h1>
            {{ $t("Signin.welcome_back") }}
          </h1>

          <h3 v-html="$t('make_planning')"></h3>

          <div class="quote">
            <p v-html="$t('Signin.quote')"></p>
          </div>
        </div>

        <div class="sign-side">
          <div class="form">
            <h2>{{ $t("sign_in") }}</h2>
            <span class="subheader">
              {{ $t("Signin.do_not_have_account") }}
              <router-link :to="`/sign-up${search}`">{{ $t("Signin.sign_up") }}</router-link>
              or
              <router-link :to="`/password`">{{ $t("Signin.reset_password") }}</router-link>
            </span>

            <div class="field mt-5">
              <label for="email">{{ $t("Form.email") }}</label>
              <InputText id="email" placeholder="name@company.com" autofocus type="email" v-model="email" />
            </div>

            <div class="field">
              <label for="password">{{ $t("Form.password") }}</label>
              <InputText
                id="password"
                :placeholder="$t('Form.password_placeholder')"
                type="password"
                v-model="password"
              />
            </div>

            <Button :disabled="!isValid || busy" class="btn-submit" @click="signIn" :label="$t('sign_in')" />

            <div v-if="!jpLocale">
              <div class="or-divider mt-2 mb-1">Or</div>

              <div class="button se-button" @click="startSportsEngineAuth">
                Sign in with
                <img src="/se_logo_full.png" alt="Sports Engine" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    document.title = "Sign In | Diamond Scheduler Sports Scheduling Software";
  },
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Login to your Diamond Scheduler account. Make schedules for baseball, softball, basketball, soccer, hockey, football and many other sports.",
      },
    ],
    link: [{ rel: "canonical", href: "https://app.cactusware.com/sign-in" }],
  },
  data() {
    return {
      busy: false,
      email: this.getURLParam("email"),
      password: "",
      error: "",
      search: window.location.search,
    };
  },
  computed: {
    isValid() {
      return this.email && this.email.includes("@") && this.password.length > 7;
    },
  },
  methods: {
    signIn() {
      this.busy = true;
      this.$store
        .dispatch("signIn", {
          email: this.email.toLowerCase(),
          password: this.password,
        })
        .then(() => {
          const user = this.currentUser;
          window.analytics.identify(user.id, {
            name: user.first + " " + user.last,
            email: user.email,
          });
          localStorage.setItem("user_id", user.id);
          localStorage.setItem("user_email", user.email);
          localStorage.setItem("locale", user.locale);

          this.trackEvent("Signed In", { user: user });
          this.$store.dispatch("getLeagueInformation");
          this.makeToast("success", this.$t("Toast.welcome_back"));
          this.proceed(this.getURLParam("return") || "/");
        })
        .catch(() => {
          this.makeToast("error", this.$t("Toast.error.signin"));
          this.password = "";
          this.busy = false;
        });
    },
  },
  mounted() {
    window.analytics.page();

    setTimeout(() => {
      let focusId = "email";
      if (this.email) {
        focusId = "password";
      }
      this.focusInput(focusId);
    }, 250);
  },
};
</script>
